module.exports = __webpack_public_path__ + "img/icon-plug.6877dda8.svg";